export default __webpack_public_path__ + "static/media/codeInLogo.a47995e0.png";